import {all, call, put, takeEvery} from "redux-saga/effects";
import aliasApi from "@api/alias";
import personApi from '@api/person';
import roleApi from "@api/person-role";

import {
  AliasesActionTypes, fetchError, fetchSuccess, createError, createSuccess, deleteError, deleteSuccess,
  updateSuccess, updateError, updatePropertyItemSuccess, updatePropertyItemError, fetchItemSuccess, fetchItemError
} from "@actions/alias";
import {ReduxAction} from "@actions/index";


function* handleFetch({payload}: ReduxAction) {
  try {
    const res = yield call(aliasApi.getList, payload);
    yield put(fetchSuccess(res));
  }
  catch (err) {
    yield put(fetchError(err));
  }
}


function* handleDelete({payload}: ReduxAction) {
  try {
    yield call(aliasApi.delete, payload);
    yield put(deleteSuccess(payload));
  }
  catch (err) {
    yield put(deleteError(err))
  }
}


function* handleCreate({payload}: ReduxAction) {
  try {
    const {data} = yield call(aliasApi.create, payload);
    payload.onSuccessCallback && payload.onSuccessCallback(data);
    yield put(createSuccess(data))
  }
  catch (err) {
    yield put(createError(err));
    payload.onErrorCallback && payload.onErrorCallback(err);
  }
}


function* handleUpdate({payload}: ReduxAction) {
  try {
    const {data} = yield call(aliasApi.update, payload);
    payload.onSuccessCallback && payload.onSuccessCallback(data);
    yield put(updateSuccess(data))
  }
  catch (err) {
    yield put(updateError(err));
    payload.onErrorCallback && payload.onErrorCallback(err);
  }
}

function* handleFetchItem({payload}: ReduxAction) {
  try {
    const {type, reference_id} = payload.payload;
    const apiMethodType = type === 'person' ? personApi.getItem : roleApi.getItem;
    
    // data and info apis in parallel :
    const [aliasPayLoad, referencePayLoad] = yield all([
      call(aliasApi.getItem, payload),
      call(apiMethodType, {params: {id: reference_id}})
    ])
    const aliasData = aliasPayLoad.data;
    const referenceData = referencePayLoad.data;
    
    yield put(fetchItemSuccess({aliasData, referenceData}));
  }
  catch (err) {
    yield put(fetchItemError(err))
  }
}

function* handleUpdatePropertyItem({payload}: ReduxAction) {
  try {
    const {data} = yield call(aliasApi.updatePropertyItem, payload);
    payload.onSuccessCallback && payload.onSuccessCallback(data);
    yield put(updatePropertyItemSuccess(data))
  }
  catch (err) {
    yield put(updatePropertyItemError(err));
    payload.onErrorCallback && payload.onErrorCallback(err);
  }
}


/*************************************************************
 **************************************************************/


function* aliasesSaga() {
  yield all([
    yield takeEvery(AliasesActionTypes.FETCH_REQUEST, handleFetch),
    yield takeEvery(AliasesActionTypes.DELETE_REQUEST, handleDelete),
    yield takeEvery(AliasesActionTypes.CREATE_REQUEST, handleCreate),
    yield takeEvery(AliasesActionTypes.UPDATE_REQUEST, handleUpdate),
    yield takeEvery(AliasesActionTypes.FETCH_ITEM_REQUEST, handleFetchItem),
    yield takeEvery(AliasesActionTypes.UPDATE_PROPERTY_ITEM_REQUEST, handleUpdatePropertyItem)
  ])
}

export default aliasesSaga
